import { Component } from 'js-component-framework';
import SmoothScroll from '../../utilities/SmoothScroll';

/**
 * Component for instantiating cta buttons.
 */
export default class ButtonCTA extends Component {

  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.button = document.querySelector('.cta-button');

    // Initalizations
    if (this.button.classList.contains('cta-button--slide')) {
      this.init();
    }
  }

  /**
   * Init
   */
  init() {
    this.setSmoothScroll = new SmoothScroll('.cta-button--slide');
    this.setSmoothScroll.init();
  }
}



// WEBPACK FOOTER //
// ./client/js/components/ButtonCTA/ButtonCTA.js